<template>
	<main>
		<div
			class="flex items-center justify-center bg-center bg-cover text-white"
			style="background-image: url(https://unsplash.com/photos/GRQMIqNw55k/download?force=true)"
		>
			<div class="w-full h-full flex flex-col items-center justify-center p-16" style="background-color: rgb(0, 0, 0, 0.8);">
				<!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/q5jauHt8YFE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
				<div class="max-w-4xl text-xl text-center">
					Whenever a government or civil authority forbids Christians to do that which God commands, or commands Christians to do that which God forbids, Christians must obey God, rather than men.
					<div>Acts 5:29</div>
				</div>
				<div class="max-w-4xl text-lg mt-4 text-center">
					每当政府或民权机构禁止基督徒去做上帝所命令的事情或者政府命令基督徒去做上帝所禁止的事情时，圣经中的上帝之道就有义务基督徒违抗民权并服从上帝。
					<div class="text-sm italic">
						《 彼得和众使徒回答说：顺从神，不顺从人，是应当的。》使徒行傳 5:29
					</div>
				</div>
			</div>
		</div>
		<div class="w-full flex flex-col md:flex-row items-center md:items-start justify-center my-12">
	<!-- 		<div class="w-full max-w-xs">
				<h2 class="text-4xl tracking-wide mb-4 font-black">Articles</h2>
			</div> -->
			<div class="w-full md:w-2/3 px-4 max-w-4xl pr-8">
				<h2 class="text-4xl tracking-wide mb-4 font-black">Videos</h2>
				<div v-for="{title, id} in videos" class="py-4 text-xl">
					<a target="_blank" class="hover:text-gray-600 flex flex-col">
						<div class="video-container">
							<iframe
								class="video-iframe"
								:src="`https://www.youtube.com/embed/${id}`"
								allowfullscreen
							></iframe>
						</div>
						<div class="text-center mt-4 mb-8">{{ title }}</div>
					</a>
				</div>
			</div>
			<div class="w-full md:w-1/3 px-4 md:border-l border-gray-600 md:pl-8">
				<h2 class="text-4xl tracking-wide font-black">News</h2>
				<div v-for="{title, link} in news" class="py-4 text-xl border-b border-gray-600">
					<a target="_blank" :href="link" class="hover:text-gray-600">{{ title }}</a>
				</div>
				<h2 class="text-4xl tracking-wide font-black mt-8">Articles</h2>
				<div v-for="{title, link} in articles" class="py-4 text-xl border-b border-gray-600">
					<a target="_blank" :href="link" class="hover:text-gray-600">{{ title }}</a>
				</div>
				<div class="w-full flex flex-col text-2xl mt-8">
					<div class="">Pastor WangYi in chains for the Gospel in China:</div>
					<div>
						<label id="years">00</label> Year,
						<label id="days">00</label> Days,
						<label id="hours">00</label>:
						<label id="minutes">00</label>:
						<label id="seconds">00</label></div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import Swal from 'sweetalert2';

export default {
	data() {
		return {
			videos: [
				{
					title: 'When to Resist, When to Submit',
					id: 'q5jauHt8YFE'
				},
				{
					title: 'Repentance - Paul Washer',
					id: '6mcpWQVgDDI'
				},
				{
					title: 'Jesus Christ came into the world to save sinners- (The Meaning of Christmas)  John MacArthur',
					id: 'tfHkDnWtpVY'
				},
				{
					title: 'The Gospel of Jesus Christ- Paul Washer',
					id: 'gy-XgK0VW9M'
				},
				{
					title: 'The Holiness of God- RC Sproul',
					id: 'SErpRpUeDAQ'
				},
				{
					title: 'Persecution in China- John MacArthur with Dr. Daniel Wang',
					id: '08CNJziEChs'
				},
				{
					title: 'The Role of Civil Authority - RC Sproul',
					id: 'Z1IYd58YhCk'
				},
				{
					title: 'Xi Jinping Must Repent',
					id: 'eWuv55YgKjY'
				},
				{
					title: '第十屆聖詩頌唱會 26 主為保障 A Mighty Fortress is Our God',
					id: 'd18GK6ArWnY'
				}
			],
			news: [
				{
					link: 'https://www.christianpost.com/news/china-trying-to-rewrite-the-bible-force-churches-sing-communist-anthems.html',
					title: 'China Plans To “Re-write” The Bible- Christian Post'
				},
				{
					link: 'https://www.crosswalk.com/headlines/contributors/michael-foust/china-bans-kids-from-attending-church-threatens-parents-who-break-law-watchdog.html',
					title: 'China Bans Children From Attending Church With Their Parents- ONN'
				},
				// {
				// 	link: 'https://www.state.gov/conviction-of-chinese-christian-pastor-wang-yi/',
				// 	title: 'U.S. State Department Demands Release Of Pastor Wang Yi'
				// },
				{
					link: 'https://time.com/5757591/wang-yi-prison-sentence-china-christianity/',
					title: 'Prison Sentence for Pastor Shows China Feels Threatened by Spread of Christianity- Time'
				},
				// {
				// 	link: 'https://www.christianpost.com/news/trump-admin-condemns-imprisonment-of-chinese-pastor-wang-yi-calls-for-his-release-we-are-alarmed.html',
				// 	title: 'Trump Administration Condemns Imprisonment Of Chinese Christian Pastor'
				// }
			],
			articles: [
				{
					link: 'https://www.facebook.com/prayforearlyrain/',
					title: 'Early Rain Christian Church Facebook Page'
				},
				{
					link: '/article',
					title: 'Letter Published After Pastor Wang Yi\'s Arrest'
				},
				{
					link: 'http://the-end-time.blogspot.com/2014/11/the-chinese-macarthur-study-bible-1000.html',
					title: 'MacArthur Study Bible Given To 1000 Chinese Pastors'
				}
			]
		}
	},
	mounted() {
		var yearsLabel = document.getElementById("years");
		var daysLabel = document.getElementById("days");
		var hoursLabel = document.getElementById("hours");
		var minutesLabel = document.getElementById("minutes");
		var secondsLabel = document.getElementById("seconds");
		var totalSeconds = ((new Date() - new Date(2018, 12, 9))/1000).toFixed(0)
		setInterval(setTime, 1000);

		function setTime() {
			++totalSeconds;
			yearsLabel.innerHTML = parseInt(totalSeconds / (60*60*24*365));
			daysLabel.innerHTML = parseInt((totalSeconds % (60*60*24*365)) / (60*60*24));
			hoursLabel.innerHTML = parseInt((totalSeconds % (60*60*24)) / (60*60));
			minutesLabel.innerHTML = pad(parseInt((totalSeconds % (60*60)) / 60));
			secondsLabel.innerHTML = pad(totalSeconds % 60);
		}

		function pad(val) {
			var valString = val + "";
			if (valString.length < 2) {
				return "0" + valString;
			} else {
				return valString;
			}
		}
	}
};
</script>

<style>

</style>
